import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  PLATFORM_ID, SimpleChanges
} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {environment} from "@environment";
import {Country, EventItem, Lookups} from "@model";
import {AbstractComponent} from "../abstract.component";
import {DatePipe, isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-event-grid-item-with-image-alt',
  templateUrl: './event-grid-item-with-image-alt.component.html',
  styleUrls: ['./event-grid-item-with-image-alt.component.scss'],
  providers: [DatePipe]
})
export class EventGridItemWithImageAlt extends AbstractComponent implements OnInit, OnChanges {
  @Input() eventItem?: EventItem;
  @Input() additionalClass?: string;
  @Input() isLanding = false;
  @Input() isFinishedEvent = false;
  @Input() countries: Country[] = [];
  @Input() isOnWishList = false;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() isPreviewComponent?: boolean;
  @Input() zoomEffect = false;
  @Output() onRightButtonClickCallback: EventEmitter<void> = new EventEmitter<void>();

  eventCountry?: Country;
  lengths: (string | undefined)[] = [];
  isSmallerThanXl = false;
  isXsScreen = false;
  isBrowser: boolean;

  constructor(
    public translocoService: TranslocoService,
    private datePipe: DatePipe,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    super();
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.setEventCountry();
    this.setEventLengths();
    this.checkScreenSize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['eventItem'] && changes['eventItem'].currentValue?.id !== changes['eventItem'].previousValue?.id) {
      this.setEventCountry();
      this.setEventLengths();
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.isBrowser) {
      this.checkScreenSize();
    }
  }

  checkScreenSize() {
    if (!this.isBrowser) return;

    this.isSmallerThanXl = window.innerWidth < 1200;
    this.isXsScreen = window.innerWidth < 576;
  }

  handleCardClick() {
    if (this.isSmallerThanXl) {
      this.onRightButtonClick();
    }
  }

  setEventCountry(): void {
    if (this.countries.length && this.eventItem?.country) {
      this.eventCountry = this.countries.find(item => item.id === this.eventItem?.country);
    }
  }

  setEventLengths(): void {
    if (this.eventItem?.lengths?.length) {
      // @ts-ignore
      this.lengths = this.eventItem.lengths.sort((a, b) => (a || 0) - (b || 0)).slice(0, this.listSizeBreakpoint)
    } else {
      this.lengths = Array.from(new Set(this.eventItem?.racesList?.map(race=>race.length).sort((a, b) => (a || 0) - (b || 0)).map(length => length?.toString())));
    }
  }

  formatDate(date: Date | string): string {
    return this.datePipe.transform(date, 'MMM', undefined, this.getLocale())?.slice(0, 3)?.toUpperCase() ?? '';
  }

  getLocale() {
    let activeLang = this.translocoService.getActiveLang();
    switch(activeLang){
      case 'hr':
        return 'hr';
      case 'en':
        return 'en';
      case 'it':
        return 'it';
      case 'slo':
        return 'slo';
      case 'sr':
        return 'sr-Latn';
      case 'bs':
        return 'sr-Latn';
      default:
        return 'en';
    }
  }

  protected readonly environment = environment;

  onRightButtonClick(): void {
    this.onRightButtonClickCallback.emit();
  }
}
